module.exports = __webpack_public_path__ + "img/001-spotify.7a3fcb73.svg";